// Angular imports
import { Injectable } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class DomParserService {
  constructor(private sanitizer: DomSanitizer) {}

  getParsedHTMLString(
    content: string,
    callbackName: string,
    tagName: string,
    ...attributes: string[]
  ): SafeHtml {
    let htmlContent = content.toString();
    const parser = new DOMParser();
    const parsedHtml = parser.parseFromString(htmlContent, 'text/html');
    const elements = parsedHtml.getElementsByTagName(tagName);
    for (let i = 0; i < elements.length; i++) {
      const el: Element = elements[i];
      const callbackArgs = attributes.map((attr) => {
        return el.attributes.getNamedItem(attr).value;
      });
      callbackArgs.push(`'${el.innerHTML}'`);
      const replaceHTML = `<a class="cc-clickable-link" href="javascript:void(0);" onclick="${callbackName}(${callbackArgs})">${el.innerHTML}</a>`;
      htmlContent = htmlContent.replace(el.outerHTML, replaceHTML);
    }
    return this.sanitizer.bypassSecurityTrustHtml(htmlContent);
  }
}
